import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconScubaDiving = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconScubaDiving",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m210-240 31-178q3-24 19-42t41-25l379-115 77-154 8-11 95-95q8-8 20-8t21 9q8 8 9 20t-7 19l-83 96-56 171-6 12q-4 6-9 9L560-400l-234 74-44 120-2 6q-1 3-4 5L184-72q-10 14-26 16t-30-8-16-26 8-30zm-90-120q-33 0-56-23t-24-57 24-56 56-24 57 24 23 56-23 57-57 23m236-196q-24 7-45-5t-29-37 6-46 36-28l143-38q16-5 30 4t19 25l11 38q5 16-4 30t-25 19z"
  })
}));